import { colors } from '@ardoq/design-tokens';
import { ARDOQ_DEFAULT_FONT_FAMILY } from '@ardoq/typography';
import { HtmlCanvasVisual, IRenderContext, Rect } from '@ardoq/yfiles';
import {
  MODERNIZED_BLOCK_DIAGRAM_FONT_SIZE as FONT_SIZE,
  MODERNIZED_BLOCK_DIAGRAM_LINE_HEIGHT as LINE_HEIGHT,
} from '@ardoq/graph-labeling';

const FONT = `${FONT_SIZE}px ${ARDOQ_DEFAULT_FONT_FAMILY}`;
class CanvasLabelVisual extends HtmlCanvasVisual {
  /**
   * @param textBounds the text bounds.
   * @param backgroundBounds the bounds of the white background rectangle. leave this as null to omit the white background rectangle.
   * @param label the wrapped label, expressed as an array of strings, where each string is a line of text.
   */
  constructor(
    private textBounds: Rect,
    private backgroundBounds: Rect | null,
    private label: string[],
    private opacity: number
  ) {
    super();
  }
  render(_: IRenderContext, ctx: CanvasRenderingContext2D): void {
    const { globalAlpha } = ctx;
    ctx.globalAlpha = this.opacity;
    ctx.fillStyle = colors.white950;
    if (this.backgroundBounds) {
      const { x, y, width, height } = this.backgroundBounds;
      ctx.fillRect(x, y, width, height);
    }
    ctx.font = FONT;
    ctx.fillStyle = colors.black950;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    const { y, centerX } = this.textBounds;
    const topLineY = y + LINE_HEIGHT / 2;
    this.label.forEach((line, lineIndex) => {
      ctx.fillText(line, centerX, topLineY + LINE_HEIGHT * lineIndex);
    });
    ctx.globalAlpha = globalAlpha;
  }
}
export { CanvasLabelVisual };
